import React, { useState, useContext, useEffect, useMemo } from "react";
import "./attachments.scss";
import { ProcessContext } from "../../ProcessLayoutWrapper";
import { useSelector } from "react-redux";
import AttachmentTable from "./AttachmentTable";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";

import apiService from "~/services/service";
import API_ROUTES from "~/api-routes";
import { getFilenameFromReference } from "~/utils/fileUtils";
import { useParams } from "react-router-dom";

const ProcessAttachments = () => {
  const {
    formatDate,
    fetchProcessAttachments,
    statesAttachment,
    handleDeleteDocument,
    handleConfirmDeleteDocumment,
    handleRestoreDocument,
    setStatesAttachment,
    fetchPayslipMatching,
    paySlipMatchingResult,
    loading,
    handleDeletePayslip,
    handleUndoPayslip,
    milestones,
  } = useContext(ProcessContext);
  const { id } = useParams();
  const { processAttachments, loadingAttachments } = useSelector(
    (state) => state.attachments,
  );
  const { processdata } = useSelector((state) => state.process);
  const [rows, setRows] = useState(10);
  const [first, setFirst] = useState(0);

  const onPageChange = (e) => {
    setRows(e.rows);
    setFirst(e.first);
  };

  useEffect(() => {
    if (processdata?.id) {
      fetchProcessAttachments();
    }
    fetchPayslipMatching("released");
  }, [processdata?.id]);
  const attachmentData = useMemo(() => {
    if (!paySlipMatchingResult && !processAttachments) return [];
    const task =
      milestones?.filter((data) => data?.name === "Submit Final Output") ?? [];
    const owner = task[0]?.taskData?.find(
      (task) => task.name === "Submit output to Customer",
    )?.owner;

    const payslipData =
      paySlipMatchingResult?.map((data) => ({
        name: getFilenameFromReference(data?.file_reference),
        original_file_name: data?.extracted_data?.original_filename,
        file_type: "application/pdf",
        blob_url: data?.file_reference,
        createdByData: {
          first_name: data?.userData?.first_name,
          last_name: data?.userData?.last_name,
          email: data?.userData?.email,
        },
        createdAt: data?.createdAt,
        size: data?.extracted_data?.fileSize,
        isPayslipData: true,
        id: data?.id,
        created_by: data?.userData?.id,
        owner: owner?.toUpperCase(),
        category: "PAYSLIPS_AND_PAYROLL_REPORTS",
        subCategory: "PAYSLIPS",
      })) ?? [];

    return [...payslipData, ...(processAttachments ?? [])].sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
    );
  }, [paySlipMatchingResult, processAttachments, milestones]);

  return (
    <>
      {statesAttachment?.temporaryMessage && (
        <TemporaryNotification
          onUndo={
            statesAttachment?.selectedFile?.isPayslipData
              ? handleUndoPayslip
              : handleRestoreDocument
          }
          setMessages={(value) =>
            setStatesAttachment((prev) => ({
              ...prev,
              temporaryMessage: value,
            }))
          }
          successMsg={statesAttachment?.temporaryMessage}
        />
      )}

      {statesAttachment?.restoreMessage && (
        <AttachmentSuccess
          successMsg={statesAttachment?.restoreMessage}
          setMessages={(value) =>
            setStatesAttachment((prev) => ({ ...prev, restoreMessage: value }))
          }
        />
      )}
      <AttachmentTable
        first={first}
        rows={rows}
        onPageChange={onPageChange}
        formatDate={formatDate}
        processAttachments={attachmentData}
        loadingAttachments={loadingAttachments || loading}
        handleAttachmentDelete={handleDeleteDocument}
        attachmentConfirmModal={statesAttachment?.attachmentConfirmModal}
        setAttachmentConfirmModal={(value) =>
          setStatesAttachment((prev) => ({
            ...prev,
            attachmentConfirmModal: false,
          }))
        }
        isAttachmentLoader={statesAttachment?.isAttachmentLoader}
        relatedType="PROCESS"
        relatedId={id}
      />
      {statesAttachment?.attachmentConfirmModal && (
        <DocumentConfirmationDialog
          visible={statesAttachment?.attachmentConfirmModal}
          closeModal={(value) =>
            setStatesAttachment((prev) => ({
              ...prev,
              attachmentConfirmModal: false,
            }))
          }
          handleSave={
            statesAttachment?.selectedFile?.isPayslipData
              ? handleDeletePayslip
              : handleConfirmDeleteDocumment
          }
          isLoader={statesAttachment?.isAttachmentLoader}
        />
      )}
    </>
  );
};

export default ProcessAttachments;
